import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// const rootElement = document.getElementById('questionnaire-form-root');
// const formId = rootElement ? rootElement.getAttribute('data-form-id') : null;
// const formType = rootElement
//   ? rootElement.getAttribute('data-form-type')
//   : 'diagnostic';
// const branchName = rootElement
//   ? rootElement.getAttribute('data-branch-name')
//   : null;

// if (rootElement) {
//   const root = createRoot(rootElement);
//   root.render(
//     <App formId={formId} formType={formType} branchName={branchName} />
//   );
// }

(function () {
  const mounts = new Map();

  function parseProps(el) {
    try {
      return JSON.parse(el.getAttribute('data-props') || '{}');
    } catch (e) {
      return {};
    }
  }

  function mount(el, overrideProps) {
    if (!el || mounts.has(el)) return;
    const props = Object.assign({}, parseProps(el), overrideProps || {});
    const root = createRoot(el);
    root.render(<App {...props} />);
    mounts.set(el, root);
  }

  function unmount(el) {
    const handle = mounts.get(el);
    if (!handle) return;
    handle.unmount();
  }

  function initAll() {
    document
      .querySelectorAll('.questionnaire-form:not([data-mounted])')
      .forEach((el) => mount(el));
  }

  // Observe dynamically inserted placeholders
  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes &&
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (
              node.matches &&
              node.matches('.questionnaire-form:not([data-mounted])')
            )
              mount(node);
            node.querySelectorAll &&
              node
                .querySelectorAll('.questionnaire-form:not([data-mounted])')
                .forEach(mount);
          }
        });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Public API
  window.Questionnaire = {
    mount, // mount(containerEl, overrideProps?)
    unmount, // unmount(containerEl)
    mountIn: (container, props) => {
      // Create a placeholder yourself + mount with props:
      const el = document.createElement('div');
      el.className = 'questionnaire-form';
      el.setAttribute('data-props', JSON.stringify(props || {}));
      container.appendChild(el);
      mount(el);
      return el; // return placeholder reference
    },
  };

  document.readyState !== 'loading'
    ? initAll()
    : document.addEventListener('DOMContentLoaded', initAll);
})();
